module.exports = __webpack_public_path__ + "static/Lamentum4-28c2f191f3991a9d7e1945155d536db0.png";